import { render, staticRenderFns } from "./GraficoCadastrosMarketingCard.vue?vue&type=template&id=57b06b98"
import script from "./GraficoCadastrosMarketingCard.vue?vue&type=script&lang=ts"
export * from "./GraficoCadastrosMarketingCard.vue?vue&type=script&lang=ts"
import style0 from "./GraficoCadastrosMarketingCard.vue?vue&type=style&index=0&id=57b06b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports